/*
|--------------------------------------------------------------------------
| Views: Gallery Article
|--------------------------------------------------------------------------
*/

/**
 * Featured Gallery
 * @namespace
 */
__gh__webApp.views.galleryArticle = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	}

};